module.exports = __webpack_public_path__ + "assets/234dbb6d3f8605d27f1fbd9768b6991e.png";